// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1nJ_x","Closed":"SideDrawer_Closed__1-Rrs","Open":"SideDrawer_Open__1_MTw"};